import { Alert, Center, Loader } from '@mantine/core';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';

import { useUsuario } from '../api/sessao';
import { Demo } from '../pages/Demo';
import { Inicio } from '../pages/Inicio';
import { Login } from '../pages/Login';
import { NaoEncontrada } from '../pages/NaoEncontrada';
import { PAGINAS, redirecionamentoLegado, rotaNova } from './paginas';
import { COMPONENTES } from './rotas';
import { Shell } from './Shell';

/** Links salvos do Streamlit (`/?page=<slug>`) vão para a página nova. */
function RedirecionaLinksAntigos() {
  const { pathname, search } = useLocation();
  const navegar = useNavigate();
  useEffect(() => {
    if (pathname !== '/') return;
    const alvo = redirecionamentoLegado(search);
    if (!alvo) return;
    navegar(alvo, { replace: true });
  }, [pathname, search, navegar]);
  return null;
}

function AreaLogada() {
  const { data: usuario, isPending, isError } = useUsuario();
  const { pathname, search } = useLocation();

  if (isPending) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  if (isError) {
    return (
      <Center h="100vh">
        <Alert color="red">Não foi possível falar com o servidor.</Alert>
      </Center>
    );
  }
  if (!usuario) {
    const proximo = encodeURIComponent(pathname + search);
    return <Navigate to={`/login?next=${proximo}`} replace />;
  }
  return <Shell usuario={usuario} />;
}

export function App() {
  return (
    <>
      <RedirecionaLinksAntigos />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<AreaLogada />}>
          <Route index element={<Inicio />} />
          <Route path="demo" element={<Demo />} />
          {PAGINAS.map((p) => {
            const Pagina = COMPONENTES[p.slugLegado];
            return Pagina ? (
              <Route key={p.slugLegado} path={rotaNova(p).slice(1)} element={<Pagina />} />
            ) : null;
          })}
          <Route path="*" element={<NaoEncontrada />} />
        </Route>
      </Routes>
    </>
  );
}
